import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from '@codex/themes';
import Credit from './Credit';
import uiLocale from '../../../utils/UILocale';

const translations = {
  example: uiLocale
    .getString('component.productCreditInfo.product_detail_credit_available_one_example'),
  caption: uiLocale.getString('component.productCreditInfo.product_detail_credit_caption_info'),
  detail: uiLocale.getString('component.productCreditInfo.product_detail_credit_available')
};

export default function initCredit(mountEl) {
  ReactDOM.render(
    <Provider store={window.appState}>
      <ThemeProvider theme={themes.currys}>
        <Credit translations={translations} />
      </ThemeProvider>
    </Provider>, mountEl
  );
}
